import React, {useEffect} from 'react';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography
} from "@one-thd/sui-atomic-components";
import { bool, func } from "prop-types";

export const AbandonSelectionWarning = ({ handleClose, onConfirm, open }) => {

  if (!open) {
    return null;
  }
  return (
    <Modal open={open} onClose={handleClose}>
      <ModalHeader onClose={handleClose}>Are You Sure You Want to Exit?</ModalHeader>
      <ModalBody>
        <Typography data-testid="warning-abandon-message" variant="body-base">
          Exiting now will discard your current selections and you'll lose any progress you've made. Are you sure you want to continue?
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <ButtonGroup>
          <Button data-testid="warning-cancel" onClick={handleClose} variant="secondary">Cancel</Button>
          <Button data-testid="warning-exit" onClick={onConfirm} variant="primary">Discard and Exit</Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
};

AbandonSelectionWarning.prototype = {
  handleClose: func.isRequired,
  onConfirm: func.isRequired,
  open: bool.isRequired
}
